var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:("collaboratorModal-" + _vm.id),attrs:{"size":"xl","title":_vm.$t('modalTitleCollaborators'),"ok-only":"","ok-title":_vm.$t('buttonClose')}},[_c('CollaboratorTable',{attrs:{"getData":_vm.getData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }